function handleKlaviyoInteractions(config) {
  const {
    formSelector,
    onSuccess,
    onError,
    customSource = 'Product Back-in-Stock Form',
    extraProperties = {},
  } = config;

  const LIST_ID_FIELD_NAME = 'g';
  const COMPANY_ID_FIELD_NAME = 'company_id';
  const VARIANT_ID_FIELD_NAME = 'variant_id';
  const NEWSLETTER_CHECKBOX_NAME = 'signup_mailing_list';

  const form = document.querySelector(formSelector);

  if (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      form.classList.remove('form-success');

      const formData = new FormData(form);
      const formDataObj = Object.fromEntries(formData.entries());

      const listId = formDataObj[LIST_ID_FIELD_NAME];
      const companyId = formDataObj[COMPANY_ID_FIELD_NAME];
      const variantId = formDataObj[VARIANT_ID_FIELD_NAME];
      const isNewsletterRequested =
        formDataObj[NEWSLETTER_CHECKBOX_NAME] === 'on';

      if (!companyId) {
        console.error('Company ID not found.');
        if (onError) onError(new Error('Company ID not found'));
        return;
      }
      if (!variantId) {
        console.error('Variant ID not found.');
        if (onError) onError(new Error('Variant ID not found'));
        return;
      }

      const backInStockPayload = {
        email: formDataObj.email,
      };

      const newsletterPayload = {...formDataObj};
      delete newsletterPayload[LIST_ID_FIELD_NAME];
      delete newsletterPayload[COMPANY_ID_FIELD_NAME];
      delete newsletterPayload[VARIANT_ID_FIELD_NAME];
      delete newsletterPayload[NEWSLETTER_CHECKBOX_NAME];

      try {
        await submitToKlaviyoBackInStock(
          backInStockPayload,
          companyId,
          variantId,
        );

        if (isNewsletterRequested && listId) {
          await submitToKlaviyoNewsletter(
            newsletterPayload,
            companyId,
            listId,
            customSource,
            extraProperties,
          );
        }

        handleSuccess($(form), onSuccess);
      } catch (error) {
        handleError($(form), error, onError);
      }
    });
  }
}

async function submitToKlaviyoBackInStock(formData, companyId, variantId) {
  const apiUrl = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`;
  const formattedVariantId = `$shopify:::$default:::${variantId}`;

  const payload = {
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: formData.email,
            },
          },
        },
        channels: ['EMAIL'],
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: formattedVariantId,
          },
        },
      },
    },
  };

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      revision: '2025-01-15',
      'content-type': 'application/vnd.api+json',
    },
    body: JSON.stringify(payload),
  });

  if (response.status !== 202) {
    const data = await response.json();
    throw new Error(
      data.errors?.[0]?.detail || 'Back in stock subscription failed',
    );
  }
}

async function submitToKlaviyoNewsletter(
  formData,
  companyId,
  listId,
  customSource,
  extraProperties,
) {
  const apiUrl = `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`;

  const payload = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: customSource,
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: formData.email,
              first_name: formData.first_name,
              last_name: formData.last_name,
              properties: extraProperties,
              subscriptions: {
                email: {
                  marketing: {
                    consent: 'SUBSCRIBED',
                  },
                },
              },
            },
          },
        },
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: listId,
          },
        },
      },
    },
  };

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      revision: '2025-01-15',
      'content-type': 'application/vnd.api+json',
    },
    body: JSON.stringify(payload),
  });

  if (response.status !== 202) {
    const data = await response.json();
    throw new Error(
      data.errors?.[0]?.detail || 'Newsletter subscription failed',
    );
  }
}

function handleKlaviyoSubscription(config) {
  const {
    formSelector,
    companyId,
    onSuccess,
    onError,
    customSource = 'Website subscription form',
    extraProperties = {},
  } = config;

  const LIST_ID_FIELD_NAME = 'g';
  const COMPANY_ID_FIELD_NAME = 'company_id';

  $(document).ready(() => {
    $(formSelector).on('submit', async function (event) {
      event.preventDefault();
      const $form = $(this);
      $form.removeClass('form-success');

      const formData = $form.serializeArray().reduce((obj, item) => {
        obj[item.name] = item.value;
        return obj;
      }, {});

      const listId = formData[LIST_ID_FIELD_NAME];
      if (!listId) {
        console.error(
          `List ID not found. Input name="${LIST_ID_FIELD_NAME}" missing.`,
        );
        if (onError) onError();
        return;
      }

      const actualCompanyId = companyId || formData[COMPANY_ID_FIELD_NAME];
      if (!actualCompanyId) {
        console.error('Company ID not found.');
        if (onError) onError();
        return;
      }

      delete formData[LIST_ID_FIELD_NAME];
      delete formData[COMPANY_ID_FIELD_NAME];

      try {
        await submitToKlaviyoNewsletter(
          formData,
          actualCompanyId,
          listId,
          customSource,
          extraProperties,
        );
        handleSuccess($form, onSuccess);
      } catch (error) {
        handleError($form, error, onError);
      }
    });
  });
}
window.handleKlaviyoSubscription = handleKlaviyoSubscription;

function handleSuccess($form, onSuccess) {
  const $klaviyoMessages = $form.find('.klaviyo_messages');
  const $successMessage = $form.find('.success_message');

  $form.addClass('form-success');

  if ($klaviyoMessages.length) $klaviyoMessages.show();
  if ($successMessage.length) $successMessage.show();

  if (onSuccess) onSuccess();
}

function handleError($form, error, onError) {
  const $klaviyoMessages = $form.find('.klaviyo_messages');
  const $errorMessage = $form.find('.error_message');

  if ($klaviyoMessages.length) $klaviyoMessages.show();
  if ($errorMessage.length) {
    $errorMessage.text(error.message || 'An error occurred').show();
  }

  console.error('Subscription error:', error);
  if (onError) onError(error);
}

//   // --------------------------------------------------------------------------
//   // INITIALIZATION
//   // --------------------------------------------------------------------------

//   // Initialize Footer Subscription
//   handleKlaviyoSubscription({
//     formSelector: '#klaviyo-newsletter-footer',
//     customSource: 'Footer Form',
//     extraProperties: {},
//     onSuccess: function () {
//       console.log('Subscription successful');
//       const $form = $('#klaviyo-newsletter-footer');
//       const $parent = $form.closest('.newsletter-form__parent');
//       const $el = $parent.length ? $parent : $form;
//       $el.addClass('newsletter-success');

//       // Assuming Cookies library is loaded
//       if (typeof Cookies !== 'undefined' && typeof liquid__newsletterSuccess !== 'undefined') {
//          Cookies.set('newsletter-popup', 'success', {
//             expires: liquid__newsletterSuccess,
//             path: '/',
//          });
//       }
//     },
//     onError: function (error) {
//       console.error('Subscription error occurred');
//     },
//   });

//   // Initialize Back In Stock
//   handleKlaviyoInteractions({
//     formSelector: '#back-in-stock',
//     customSource: 'Product Back-in-Stock Form',
//     extraProperties: {},
//     onSuccess: function () {
//       console.log('BIS Subscription successful');
//       // Optional: Hide fields, show specific success text
//     },
//     onError: function (error) {
//       console.error('BIS Subscription error occurred:', error);
//     },
//   });
